import script from "./Swiper.vue?vue&type=script&setup=true&lang=js"
export * from "./Swiper.vue?vue&type=script&setup=true&lang=js"

import "./Swiper.vue?vue&type=style&index=0&id=6ab8b7a5&lang=scss&scoped=true"

import exportComponent from "H:\\360MoveData\\Users\\xw\\Desktop\\work\\2022\\2月\\南山网飞卡\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ab8b7a5"]])

export default __exports__